import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  const clickToHome = () => {
    navigate("/fun_learning/");
  };
  return (
    <div className="flex items-center justify-center min-h-screen bg-cover bg-center bg-no-repeat">
      <div className="max-w-md mx-auto text-center bg-white bg-opacity-90 dark:bg-gray-800 p-8 rounded-lg shadow-lg">
        <div className="text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-bold text-indigo-600 dark:text-indigo-400 mb-4">
          404
        </div>
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 dark:text-gray-100 mb-6">
          이런! 페이지를 찾을 수 없습니다.
        </h1>
        <p className="text-base sm:text-lg md:text-xl text-gray-600 dark:text-gray-300 mb-8">
          The page you're looking for seems to have gone on a little adventure.
          Don't worry, we'll help you find your way back home.
        </p>
        <button
          onClick={clickToHome}
          className="inline-block bg-indigo-600 text-white font-semibold px-4 sm:px-6 md:px-8 py-2 sm:py-3 rounded-md hover:bg-indigo-700 dark:hover:bg-indigo-500 transition-colors duration-300"
        >
          협력학습으로 돌아가기
        </button>
      </div>
    </div>
  );
};

export default NotFound;
